import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RadioBoxGroupItem from './RadioBoxGroupItem';
import { withVDSManager } from '@vds-core/utilities';

var Fragment = require('react').Fragment;

var Component = require('react').Component;

var propTypes = {
  /**
   * @ignore If provided, RadioBox components will be rendered based on this data
   * @typeName radioBoxData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    subtext: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    selected: PropTypes.bool
  })),

  /**
   * If provided, width of RadioBox components will be rendered based on this value
   */
  childWidth: PropTypes.string,

  /**
   * An object containing number of RadioBox components per row, in each viewport
   */
  rowQuantity: PropTypes.object,

  /**
   * Viewport the RadioBoxGroup will be rendered in
   */
  viewport: PropTypes.oneOf(['desktop', 'tablet', 'mobile']),

  /**
   * @Ignore
   * If provided, a height will be set on RadioBoxes in a group, only for vertical orientation
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   * Contol the orientation of all group items
   */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  childWidth: '100%',
  viewport: 'desktop'
};
var RadioBoxGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioBoxGroupWrapper",
  componentId: "sc-180hma5-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: ", ";\n  flex: 1;\n  width: 100%;\n  flex-direction: ", ";\n"])), function (_ref) {
  var orientation = _ref.orientation;
  return orientation === 'vertical' ? 'nowrap' : 'wrap';
}, function (_ref2) {
  var orientation = _ref2.orientation;
  return orientation === 'vertical' ? 'column' : 'row';
});
var Break = /*#__PURE__*/styled.div.withConfig({
  displayName: "Break",
  componentId: "sc-180hma5-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n  width: 0;\n"])));

var RadioBoxGroup = /*#__PURE__*/function (_Component) {
  _inherits(RadioBoxGroup, _Component);

  var _super = _createSuper(RadioBoxGroup);

  function RadioBoxGroup(props) {
    var _this;

    _classCallCheck(this, RadioBoxGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (e, index) {
      _this.props.onChange && _this.props.onChange(e);

      _this.setState({
        selected: e.target.value
      });
    });

    _this.state = {
      selected: _this.props.selected || undefined
    };
    return _this;
  }

  _createClass(RadioBoxGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          childWidth = _this$props.childWidth,
          rowQuantityProp = _this$props.rowQuantity,
          viewport = _this$props.viewport,
          onChange = _this$props.onChange,
          orientation = _this$props.orientation,
          disabledState = _this$props.disabledState,
          hoverState = _this$props.hoverState,
          focusState = _this$props.focusState,
          activeState = _this$props.activeState,
          minHeight = _this$props.minHeight,
          paddingProp = _this$props.padding,
          labelMargin = _this$props.labelMargin,
          typescale = _this$props.typescale,
          calcTypography = _this$props.calcTypography,
          borderColor = _this$props.borderColor,
          backgroundColor = _this$props.backgroundColor,
          height = _this$props.height,
          className = _this$props.className,
          id = _this$props.id;
      var rowQuantityVal = rowQuantityProp ? rowQuantityProp[viewport] : data.length;
      if (orientation && orientation === 'vertical') rowQuantityVal = 1;
      return /*#__PURE__*/React.createElement(RadioBoxGroupWrapper, {
        id: id,
        className: className,
        orientation: orientation,
        childWidth: childWidth,
        viewport: viewport
      }, data.map(function (child, index) {
        var text = child.text,
            id = child.id,
            inputId = child.inputId,
            width = child.width,
            subtext = child.subtext,
            disabled = child.disabled,
            name = child.name,
            outOfStock = child.outOfStock,
            childBorderColor = child.borderColor,
            childBackgroundColor = child.backgroundColor;
        var boxWidth = childWidth;
        boxWidth ? boxWidth : boxWidth = width;
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement(RadioBoxGroupItem, _extends({}, child, {
          count: data.length,
          outOfStock: outOfStock,
          disabled: disabled,
          name: name,
          id: id,
          inputId: inputId,
          index: index,
          onChange: _this2._onChange,
          rowQuantity: rowQuantityVal,
          selected: _this2.state.selected === id,
          subtext: subtext,
          text: text,
          width: boxWidth //1.0
          ,
          labelMargin: labelMargin,
          orientation: orientation,
          minHeight: minHeight,
          padding: paddingProp,
          typescale: typescale,
          calcTypography: calcTypography,
          disabledState: disabledState,
          hoverState: hoverState,
          focusState: focusState,
          activeState: activeState,
          borderColor: childBorderColor || borderColor,
          backgroundColor: childBackgroundColor || backgroundColor,
          height: height
        })), (index + 1) % rowQuantityVal == 0 && /*#__PURE__*/React.createElement(Break, null));
      }));
    }
  }]);

  return RadioBoxGroup;
}(Component);

RadioBoxGroup.propTypes = propTypes;
RadioBoxGroup.defaultProps = defaultProps;
export default withVDSManager(RadioBoxGroup);